import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitMdfActivities = createSelector(
  [selectFinancialCockpitState],
  ({ mdfActivities }) => mdfActivities
)
